import getAxiosInstance from '../../../../../../helpers/get_axios_instance'
import lrsAdapter from '../../../../../../helpers/lrs_adapter'

export class TablaCamionesListosParaBrutoService {
  static async getDataCamionesListosParaBruto () {
    const axios = getAxiosInstance()
    const orden = '{"orden":["fecha_de_egreso_calado"]}'
    return axios.get(`consulta_cea_lista_para_bruto_listado?r=${orden}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }
}
